import { useBackend } from "../../services";

export const useGetSubscriptions = () => {
  const { get } = useBackend();
  const getSubscriptions = () => get("subscriptions");
  return { getSubscriptions };
};
